import { render, staticRenderFns } from "./CostBearerPayFilterModal.vue?vue&type=template&id=53ec4167&"
import script from "./CostBearerPayFilterModal.vue?vue&type=script&lang=ts&"
export * from "./CostBearerPayFilterModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports